import { render, staticRenderFns } from "./range-editor.vue?vue&type=template&id=0cabcba9&scoped=true&"
import script from "./range-editor.vue?vue&type=script&lang=js&"
export * from "./range-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cabcba9",
  null
  
)

export default component.exports